"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewMarsResearchFacility = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const SelectCard_1 = require("../../../inputs/SelectCard");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
const Resources_1 = require("../../../Resources");
class NewMarsResearchFacility extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.NEW_MARS_RESEARCH_FACILITY,
            metadata: {
                cardNumber: 'Y25',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.cards(6).colon().megacredits(3).asterix();
                }),
                description: 'Draw 6 cards and keep any number of them. For each card discarded this way, gain 3 M€.',
            },
        });
    }
    play(player) {
        const game = player.game;
        const dealtCards = [];
        for (let i = 0; i < 6; i++)
            dealtCards.push(game.dealer.dealCard(game));
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            return new SelectCard_1.SelectCard('Select cards to keep', 'Keep cards', dealtCards, (foundCards) => {
                game.log('${0} kept ${1} cards', (b) => b.player(player).number(foundCards.length));
                foundCards.forEach((card) => {
                    dealtCards.splice(dealtCards.indexOf(card), 1);
                    player.cardsInHand.push(card);
                });
                return undefined;
            }, { min: 0, max: dealtCards.length });
        }));
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            player.addResource(Resources_1.Resources.MEGACREDITS, dealtCards.length * 3, { log: true });
            return undefined;
        }));
        return undefined;
    }
}
exports.NewMarsResearchFacility = NewMarsResearchFacility;
//# sourceMappingURL=NewMarsResearchFacility.js.map